import { Observable } from 'rxjs';
import { ServiceRepository } from '../domain/Service/repository';
import { Service } from '../domain/Service/model';
import HttpClient from '../utils/http-client';
import { ApiResponse } from '../domain/common/api-response';

export class ServiceRepositoryImplementation extends ServiceRepository {
  private httpClient: HttpClient;

  constructor() {
    super();
    this.httpClient = new HttpClient("", "");
  }

  createService(service: Partial<Service>): Observable<ApiResponse<Service>> {
    return this.httpClient.post('/services', service);
  }

  getService(id: number): Observable<ApiResponse<Service>> {
    return this.httpClient.get(`/services/${id}`);
  }

  getServices(page: number, limit: number, query = ""): Observable<ApiResponse<Service[]>> {
    const queryParam = query ? `&query=${query}` : "";
    return this.httpClient.get(`/services?page=${page}&limit=${limit}${queryParam}`);
  }

  updateService(id: number, service: Partial<Service>): Observable<ApiResponse<Service>> {
    return this.httpClient.put(`/services/${id}`, service);
  }

  deleteService(id: number): Observable<ApiResponse<void>> {
    return this.httpClient.delete(`/services/${id}`);
  }

  createServiceSale(data: any): Observable<ApiResponse<any>> {
    return this.httpClient.post('/services/sells', data);
  }

  getServiceInvoices(page: number, limit: number, status?: string, date_from?: string, date_to?: string): Observable<ApiResponse<any>> {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (status) params.append('status', status);
    if (date_from) params.append('date_from', date_from);
    if (date_to) params.append('date_to', date_to);
    return this.httpClient.get(`/services/invoices?${params.toString()}`);
  }

  getServiceConflicts(page: number, limit: number): Observable<ApiResponse<any>> {
    return this.httpClient.get(`/services/conflicts?page=${page}&limit=${limit}`);
  }

  resolveServiceConflict(bill_id: number, force_generate: boolean): Observable<ApiResponse<any>> {
    return this.httpClient.post(`/services/conflicts/${bill_id}/resolve`, { force_generate });
  }
}
